// extracted by mini-css-extract-plugin
export default {"root":"root--B39m7"};